
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14 0H6a6.007 6.007 0 00-6 6v8a6.006 6.006 0 006 6h8a6.006 6.006 0 006-6V6a6.006 6.006 0 00-6-6zM7 5a2 2 0 110 4 2 2 0 010-4zm6 10a2 2 0 110-4 2 2 0 010 4zm1.707-8.293l-8 8a1 1 0 01-1.414-1.414l8-8a1 1 0 011.414 1.414z","fill":"#2C8DFF"}})])
          )
        }
      }
    